import { Box, Button, FormLabel, Stack } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from "react";
import { CAMPAIGN_BANNER_IMAGE_ALLOWED_TYPES, FORM_INPUTFIELD_STYLES } from "../../utils/constant";
import NormalInput from '../inputs/normalInput';
import { Form, Formik } from 'formik';
import Schema from '../../schema';
import imageIconWhite from '../../assets/images/icons/ImageIconWhite.svg'
import check from '../../assets/images/icons/greenCheck.svg'
import imageIcon from '../../assets/images/icons/imageIcon.svg'
import deleteIconRed from '../../assets/images/icons/deleteIconRed.svg'
import { getCompanyid } from '../../utils/common';
import { companyUserAdd, updateCompanyUser } from '../../pages/company/action';
import NumberInput from '../inputs/normalInput/number';
import openEye from '../../assets/images/icons/openEye.svg'
import closeEye from '../../assets/images/icons/closeEye.svg'
import FormHeading from '../../utils/FormHeading';
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  top: '0px',
  bottom: '0px',
  right: '0%',
  left: 'revert',
  border: '0px solid red',
  borderRadius: '16px', padding: '0px',
  backgroundRepeat: 'no-repeat',
  height: 'fit-content', width: 'fit-content',
  "& .MuiDialog-container": {
    margin: 0,
  },
  "& .MuiPaper-root": {
    margin: '0px !important',
    background: "white",
    border: '0px solid blue',
    borderRadius: '0px',
    maxWidth: '100dvw',
    maxHeight: '100dvh',
    height: '100dvh', scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      width: '400px',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      width: '500px',
    },
    [theme.breakpoints.between('md', 'lg')]: {
      width: '600px',
    },
    [theme.breakpoints.up('lg')]: {
      width: '700px',
    },
  },


}));


const CreateUserModal = (props) => {
  const { open, setOpen, editedUser } = props;
  const dispatch = useDispatch();
  const [bannerImageError, setBannerImageError] = useState("")
  const [initialValues, setInitialValues] = useState(editedUser)
  const [preview, setPreview] = useState(editedUser?.photoUrl || "");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
const checkIfAllFormValueArePresent = ()=>{
  const initialFormKeys = ["contactPersonName","phoneNumber","email","id","photoUrl","password","confirmPassword","companyId"];
  const initialValues = {
    ...editedUser,companyId:getCompanyid(),phoneCountryCode:"+91"
  }
  initialFormKeys.forEach((key)=>{
    const present = Object.keys(initialValues).includes(key);
    if(!present){
      initialValues[key] = ""
    }
  })
  setPreview(editedUser?.photoUrl)
  setInitialValues(initialValues)
}
  useEffect(() => {
    checkIfAllFormValueArePresent();
  }, [editedUser])

  const handleClose = (resetForm) => {
    resetForm();
    setTimeout(() => {
      setOpen(false);
    }, 0);
  };
  return (
    <>

      <Formik
        initialValues={initialValues}
        validationSchema={Schema.addCompanyUser}
        enableReinitialize
        onSubmit={(values, { resetForm }) => {
          if (editedUser?.id) {
            values.userId = values.id;
            dispatch(updateCompanyUser(values, () => { }))
          } else {
            dispatch(companyUserAdd(values, () => { }))
          }
          resetForm();
          setOpen(false)
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          touched,
          values,
          resetForm,
        }) => {

          const handleDrop = (e) => {
            e.preventDefault();
            const file = e.dataTransfer.files[0];
            handleFile(file);
            e.target.value = null;
          };
          const handleFileChange = (e) => {
            const file = e.target.files[0];
            handleFile(file);
            e.target.value = null;
          };

          const handleFile = async (file) => {
            if (!file) return;
            if (!CAMPAIGN_BANNER_IMAGE_ALLOWED_TYPES.includes(file.type)) {
              setBannerImageError('Invalid file format. Please upload a JPEG or PNG image.')
              return;
            }
            const maxSize = 1 * 1024 * 1024;
            if (file.size > maxSize) {
              setBannerImageError('File size exceeds 1 MB. Please upload a smaller file.')
              return;
            }
            setBannerImageError("")
            const img = new Image();
            const reader = new FileReader();

            reader.onload = (e) => {
              img.src = e.target.result;

              img.onload = async () => {
                setBannerImageError("");
                const base64 = e.target.result;
                setPreview(base64);

                handleChange({
                  target: {
                    name: "photoUrl",
                    value: file,
                  }
                })
              };
            };

            reader.readAsDataURL(file);
          };
          const handleDeleteBannerImage = (e) => {
            e.preventDefault();
            e.stopPropagation();
            handleChange({
              target: {
                name: "photoUrl",
                value: "",
              }
            })
            setPreview(null);
          }


          return (
            <BootstrapDialog
              onClose={() => handleClose(resetForm)}
              aria-labelledby="customized-dialog-title ccc"
              open={open}
            >
              <Form style={{ height: '100%' }}>
                <Box sx={{ paddingX: '0px', height: '100%', position: 'relative' }}>
                  <Box sx={{ height: '10%' }}>
                    <Typography sx={{ fontSize: '20px', fontWeight: 600, color: 'black', padding: '20px 23px', borderBottom: '1px solid #F0F0F0', }}>
                      {initialValues?.id ? "Edit User" : "Create User"}
                    </Typography>
                  </Box>
                  <Box sx={{
                    padding: 0, minHeight: '82%', maxHeight: '82%', height: '82%', overflowX: 'hidden', overflowY: 'scroll', scrollbarWidth: 'none', zIndex: 1,
                    '&::-webkit-scrollbar': {
                      display: 'none',
                    }
                  }}>
                    <Box sx={{ padding: '24px', paddingTop: 0, }}>
                      <FormHeading heading="Name" isRequired={true} />
                      <NormalInput
                        name={"contactPersonName"}
                        style={FORM_INPUTFIELD_STYLES}
                        type={"text"}
                        focused={false}
                        label={("")}
                        sizeval="medium"
                        values={values?.contactPersonName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(touched.contactPersonName) && errors.contactPersonName}
                        helperText={touched.contactPersonName && errors.contactPersonName}
                      />

                    </Box>
                    <Box sx={{ padding: '24px', paddingTop: 0, }}>
                      <FormHeading heading="Email" isRequired={true} />
                      <NormalInput
                        name={"email"}
                        type={"text"}
                        focused={false}
                        label={("")}
                        sizeval="medium"
                        values={values?.email}
                        style={FORM_INPUTFIELD_STYLES}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(touched.email) && errors.email}
                        helperText={touched.email && errors.email}
                      />

                    </Box>
                    <Box sx={{ padding: '24px', paddingTop: 0, }}>
                      <FormHeading heading="Phone Number" isRequired={true} />
                      <NumberInput
                        name={"phoneNumber"}
                        type={"number"}
                        focused={false}
                        label={("")}
                        sizeval="medium"
                        values={values?.phoneNumber}
                        onChange={(e) => {
                          if (e.target.value.length <= 10) {
                            handleChange(e);
                          } else {
                            e.preventDefault();
                          }
                        }}
                        onBlur={handleBlur}
                        error={Boolean(touched.phoneNumber) && errors.phoneNumber}
                        helperText={touched.phoneNumber && errors.phoneNumber}
                        style={FORM_INPUTFIELD_STYLES}
                      />
                    </Box>
                    <Box sx={{ padding: '24px', paddingTop: 0, }}>
                      <FormHeading heading="Upload Profile Image" isRequired={true} />
                      <Box
                        onDrop={handleDrop}
                        name='photoUrl'
                        onDragOver={(e) => e.preventDefault()}
                        sx={{
                          border: '1px dashed #E5E5E5',
                          borderRadius: '16px',
                          padding: '16px',
                          textAlign: 'center',
                          cursor: 'pointer',
                          background: '#FAFAFA',
                          position: 'relative',
                          width: '100%', height: '150px'
                        }}>
                        <input
                          type="file"
                          accept="image/*"
                          id="fileInput"
                          style={{ display: 'block', height: '100%', width: '100%', border: '2px solid red', opacity: 0 }}
                          onChange={handleFileChange}
                        />
                        <label htmlFor="fileInput" style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0, padding: '16px', cursor: 'pointer' }}>
                          {preview ? (
                            <Stack
                              direction="row" justifyContent="flex-start" gap={1.5} alignItems="center"
                              sx={{
                                width: '100%',
                                height: '100%',
                                borderRadius: 2,
                                border: '0px solid red'
                              }}>
                              <Stack direction="row" justifyContent="flex-start" alignItems="center" gap={2} sx={{ height: '100px', width: '90%', background: '#F0F0F0', borderRadius: '10px', padding: '14px' }}>
                                <Box sx={{ height: '65px', width: '65px', position: 'relative' }}>
                                  <img src={preview} alt="preview" style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '5px' }} />
                                  <div style={{ position: 'absolute', top: 0, left: 0, background: 'rgba(0,0,0,0.5)', height: '100%', width: '100%', padding: '17px', borderRadius: '5px' }}>
                                    <img src={imageIconWhite} alt="imageIconWhite" style={{ height: '24px', width: '24px' }} />
                                  </div>
                                </Box>
                                {bannerImageError ? (<Typography sx={{ mt: 0.7, display: 'block', color: 'var(--red)', fontSize: '10px', fontWeight: 400, }}>
                                  {bannerImageError}
                                </Typography>) : (errors.photoUrl && touched.photoUrl) ? (
                                  <Typography sx={{ mt: 0.7, display: 'block', color: 'var(--red)', fontSize: '10px', fontWeight: 400, }}
                                    className="error">
                                    {`${errors?.photoUrl}`}
                                  </Typography>
                                ) : <>
                                  <Typography sx={{ color: '#726C6C', fontSize: '14px', fontWeight: 400, textAlign: 'left' }}>{values?.photoUrl?.name?.substring(0, 30) || "Banner Image"}</Typography> <img src={check} alt="check" style={{ height: '24px', width: '24px' }} />
                                </>}
                              </Stack>
                              <Button sx={{ "&:hover": { background: 'transparent' } }} disableRipple onClick={handleDeleteBannerImage}><img src={deleteIconRed} alt="check" style={{ height: '24px', width: '24px' }} /></Button>
                            </Stack>
                          ) : (
                            <>
                              <img src={imageIcon} alt="" style={{ height: '32px', width: '32px' }} />
                              <Typography variant="body1" sx={{ mt: 0.7, fontSize: '12px', fontWeight: 600 }}>
                                <span style={{ color: 'var(--color-blue)', textDecoration: 'underline', }}>
                                  Click to upload
                                </span>{' '}
                                or drag and drop
                              </Typography>
                              <Typography variant="caption" sx={{ mt: 0.7, display: 'block', color: '#A3A3A3', fontSize: '10px', fontWeight: 400, }}>
                                Supported dimensions (pixels) are 80x80 and 100x100. Image formats like JPEG and PNG
                              </Typography>
                              {bannerImageError && (<Typography sx={{ mt: 0.7, display: 'block', color: 'var(--red)', fontSize: '10px', fontWeight: 400, }}>
                                {bannerImageError}
                              </Typography>)}
                              {errors.photoUrl && touched.photoUrl && (
                                <Typography sx={{ mt: 0.7, display: 'block', color: 'var(--red)', fontSize: '10px', fontWeight: 400, }}
                                  className="error">
                                  {`${errors?.photoUrl}`}
                                </Typography>
                              )}
                            </>
                          )}
                        </label>
                      </Box>

                    </Box>

                    <Box sx={{ padding: '24px', paddingTop: 0, }}>
                      <FormHeading heading="Password" isRequired={true} />
                      <NormalInput
                        style={FORM_INPUTFIELD_STYLES}
                        name={"password"}
                        type={showPassword ? "text" : "password"}
                        focused={false}
                        openEyeIcon={openEye}
                        closeEyeIcon={closeEye}
                        label={("")}
                        sizeval="medium"
                        values={values.password}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(touched.password) && errors.password}
                        helperText={touched.password && errors.password}
                        handleViewPassword={() => setShowPassword((prev) => !prev)}
                        isEndAdornment={true}
                        showPassword={showPassword}
                      />

                    </Box>
                    <Box sx={{ padding: '24px', paddingTop: 0, }}>
                      <FormHeading heading="Confirm Password" isRequired={true} />
                      <NormalInput
                        style={FORM_INPUTFIELD_STYLES}
                        name={"confirmPassword"}
                        type={showConfirmPassword ? "text" : "password"}
                        focused={false}
                        openEyeIcon={openEye}
                        closeEyeIcon={closeEye}
                        label={("")}
                        sizeval="medium"
                        values={values.confirmPassword}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(touched.confirmPassword) && errors.confirmPassword}
                        helperText={touched.confirmPassword && errors.confirmPassword}
                        isEndAdornment={true}
                        handleViewPassword={() => setShowConfirmPassword((prev) => !prev)}
                        showPassword={showConfirmPassword}
                      />

                    </Box>
                  </Box>

                  <Stack direction="row" justifyContent="flex-end" alignItems="center" gap={2} sx={{ paddingX: '20px', height: '8%', position: 'sticky', bottom: 0, left: 0, right: 0, }}>
                    <Button sx={{ padding: '15px 50px', border: '1px solid white', boxSizing: 'border-box', borderRadius: '6px', color: 'black', "&:hover": { border: '1px solid #BDBDBD', boxSizing: 'border-box', background: 'white' } }} onClick={() => { setOpen(false); resetForm() }}>Cancel</Button>
                    <Button sx={{ padding: '15px 50px', borderRadius: '6px', background: 'var(--color-blue)', color: 'white', "&:hover": { background: 'var(--color-blue)' } }} type="submit">{initialValues.id ? "Update" : "Create"}</Button>
                  </Stack>
                </Box>

              </Form>
            </BootstrapDialog>
          );
        }}
      </Formik>
    </>
  )
}

export default CreateUserModal;